export const renderProperty = (property: any) => {
  if (!property) {
    return <></>;
  }

  const Component = property;

  return <Component />;
};
